module.exports = __webpack_public_path__ + "img/exclamation-circle.956ca800.svg";